<template>
  <div id="capacityType">
    <Modal
      :isOpen.sync="isModalOpen"
      :header="$t('modal.add', [$tc('vehicle.capacity')])"
      :loading="loading"
      @cancel="() => {}"
      @save="onSubmit"
    >
      <form ref="form" @submit.prevent="onSubmit">
        <Field
          :label="$t('modal.name')"
          v-model="capacityType.name"
          :maxlength="60"
          placeholder="Enter capacity type"
          required
        />
        <Field
          :label="$t('modal.description')"
          v-model="capacityType.description"
          :maxlength="60"
          placeholder="Enter description"
          required
        />
      </form>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Field from '@/components/Field.vue';
import { toast } from '@/utils/dialog';

export default {
  components: {
    Modal,
    Field
  },
  data() {
    return {
      loading: { save: false, get: false },
      isModalOpen: false,
      capacityType: {}
    };
  },
  watch: {
    isOpen(value) {
      this.isModalOpen = value;
    },
    isModalOpen(value) {
      this.$emit('update:isOpen', value);
    }
  },
  methods: {
    async onSubmit() {
      if (this.validate()) {
        this.loading.save = true;
        try {
          await this.Api.post('/vehicle_capacity_types', this.capacityType);
          this.capacityType = {};
          toast('success', this.$t('messages.saved'), 5000);
          this.isModalOpen = false;
          this.$emit('save');
        } catch (error) {
          console.error(error);
        }
        this.loading.save = false;
      }
    },
    validate() {
      let htmlValidator = false;
      if (this.$refs.form) {
        htmlValidator = this.$refs.form.checkValidity();
        if (!htmlValidator) this.$refs.form.reportValidity();
      }
      return htmlValidator;
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
#capacityType
  form
    margin-bottom: 15px
</style>
